import {
  INFO_BACKGROUND,
  INFO_COLOR,
  SUCCESS_BACKGROUND,
  SUCCESS_COLOR,
  WARNING_BACKGROUND,
  WARNING_COLOR
} from "../../../themes/themeConfigurator";

const styles = (theme) => ({
  stepName: {
    fontSize: 24,
    fontFamily: 'Roboto-Bold',
    lineHeight: '32px',
  },
  totalValueChip: {
    background: 'rgba(131, 138, 147, 0.12)',
    borderRadius: 8,
    padding: '10px 12px',
    fontFamily: 'Roboto-Bold',
    fontSize: 24,
    height: 54,
    width: '100%',

    '&.green': {
      color: SUCCESS_COLOR,
      background: SUCCESS_BACKGROUND,
    },
    '&.orange': {
      color: WARNING_COLOR,
      background: WARNING_BACKGROUND,
    },
    '&.blue': {
      color: INFO_COLOR,
      background: INFO_BACKGROUND,
    }
  },
  chipLoading: {
    fontSize: 16,
  },
  loadingIndicator: {
    color: theme.palette.primary.main,
  },
  sectionTitle: {
    textTransform: 'uppercase',
    fontSize: 12,
    fontFamily: 'Roboto-Bold',
  },
  totalChartSection: {
    [theme.breakpoints.down('md')]: {
      order: -1,
    }
  },
  totalChartLabel: {
    fontSize: 12,
    fontFamily: 'Roboto-Bold',
    textTransform: 'uppercase',
  },
  totalChartValue: {
    fontSize: 24,
    fontFamily: 'Roboto-Bold',
    [theme.breakpoints.down('md')]: {
      fontSize: 22,
    },
    '&.mid': {
      fontSize: 22,
    },
    '&.long': {
      fontSize: 20,
    },
  },
  chartLegendContainer: {
    flexGrow: 1,
    flexShrink: 1,
    minWidth: 100,
  },
  chartLegendItem: {
    margin: 0,
    zIndex: 'auto',
  }
});

export default styles;